import React from "react";
import classes from "./LoadingSpinner.module.css";

export default function LoadingSpinner() {
  return <div className={classes["loading-spinner"]}></div>;
}
